import { useLocation } from 'react-router-dom';
import qs from 'qs';

const useCategoryTree = (treeData) => {
  const location = useLocation();
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { category, subCategory, productType } = queryParams;
  let structure;

  const _stripChildren = ({ _id, slug, parent, title, isChecked = true }) => {
    return { _id, slug, parent, title, isChecked };
  };

  const _extractData = (list, checkedId) => {
    return list.map((item) =>
      _stripChildren({ ...item, isChecked: checkedId === item.slug })
    );
  };

  const _findItem = (listData, itemId) => {
    return listData.find((data) => data.slug === itemId);
  };

  if (category) {
    const foundCategory = _findItem(treeData, category);
    if (foundCategory) {
      if (subCategory) {
        const foundSubCategory = _findItem(
          foundCategory.subCategories,
          subCategory
        );

        if (foundSubCategory) {
          if (productType) {
            const foundProductType = _findItem(
              foundSubCategory.productTypes,
              productType
            );

            if (foundProductType) {
              structure = {
                categories: [_stripChildren(foundCategory)],
                subCategories: [_stripChildren(foundSubCategory)],
                productTypes: _extractData(
                  foundSubCategory.productTypes,
                  foundProductType.slug
                ),
              };
            } else {
              structure = {
                categories: [_stripChildren(foundCategory)],
                subCategories: [_stripChildren(foundSubCategory)],
                productTypes: _extractData(foundSubCategory.productTypes),
              };
            }
          } else {
            structure = {
              categories: [_stripChildren(foundCategory)],
              subCategories: _extractData(
                foundCategory.subCategories,
                foundSubCategory.slug
              ),
              productTypes: _extractData(foundSubCategory.productTypes),
            };
          }
        } else {
          structure = {
            categories: [_stripChildren(foundCategory)],
            subCategories: _extractData(foundCategory.subCategories),
          };
        }
      } else {
        structure = {
          categories: [_stripChildren(foundCategory)],
          subCategories: _extractData(foundCategory.subCategories),
        };
      }
    } else {
      structure = { categories: _extractData(treeData) };
    }
  } else {
    structure = { categories: _extractData(treeData) };
  }

  return structure;
};

export default useCategoryTree;
